import { tryCatchHelper } from '../../helpers';
import * as TYPE from './CarnetReducer';
import * as API from './CarnetService';

export const allCarnetAction = async (dispatch, params) => {
  try {
    dispatch({ type: TYPE.LOADING_ALL_CARNET, payload: true });
    const res = await API.allCarnetService(params);
    dispatch({ type: TYPE.ALL_CARNET, payload: res.data });
    dispatch({ type: TYPE.LOADING_ALL_CARNET, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: TYPE.LOADING_ALL_CARNET, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveCarnetAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await API.saveCarnetService(id, data);
    notify(res.data.message);
    if (!id) {
      await allCarnetAction(dispatch, params);
    } else {
      setActivoCarnetAction(dispatch, res.data.data);
    }
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoCarnetAction = async (dispatch, data) => {
  dispatch({ type: TYPE.ACTIVO_CARNET, payload: data });
  if (!data) {
    dispatch({ type: TYPE.STYLES_CARNET, payload: null });
  }
};

export const oneCarnetAction = async (dispatch, id) => {
  try {
    const res = await API.oneCarnetService(id);
    await setActivoCarnetAction(dispatch, res.data.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteCarnetAction = async ({ dispatch, notify }, id, params) => {
  try {
    const res = await API.deleteCarnetService(id);
    await setActivoCarnetAction(dispatch, null);
    notify(res.data.message);
    await allCarnetAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
